import { isEmpty } from 'lodash'
import * as Selectors from '~/selectors'
import * as ActionsLayer from '~/actions/layer'
import Layer from '~/models/Layer'
import { createAssetFromSourceFile } from './createAssetFromSourceFile'
import { insertLayer } from './insertLayer'
import { selectInOutPointsTimeLineAssetID } from '~/selectors/preview'
import { setInitialReference } from './timeline'

export const addSourceFileAtSliderPosition = id => (dispatch, getState) => {
  if (!id || isEmpty(id)) return

  const targetLayerIndex = 0
  const state = getState()
  const targetLayer = Selectors.getLayers(state)[targetLayerIndex]
  const inOutPointsTimeLineAssetId = selectInOutPointsTimeLineAssetID(state)
  const inOutPointsTimeLineAsset = Selectors.selectAssetById(state, inOutPointsTimeLineAssetId)
  const sourceFiles = Selectors.getSourceFilesByIds(state, [].concat(id))
  const rightSideAssets = Selectors.getRightSideAssetsBySliderTimeAndLayerByEndTime(
    state, targetLayer.id
  )
  const { sliderTime } = state.timeline

  const files = []
  let startTime = sliderTime
  sourceFiles.forEach(file => {
    const currentFile = (file.id === inOutPointsTimeLineAsset?.fileId && sourceFiles.length === 1)
      ? inOutPointsTimeLineAsset
      : file
    files.push({
      timePosition: startTime,
      file: currentFile,
    })
    startTime += currentFile.duration
  })

  const newAssets = []
  const newLayerIds = []
  const endPos = files.at(-1).timePosition + files.at(-1).file.duration
  const blockDuration = endPos - files[0].timePosition
  let assetLayerId = targetLayer.id

  if ((rightSideAssets[0]?.startTime - sliderTime) < blockDuration) {
    const newLayer = new Layer()
    dispatch(insertLayer({ index: targetLayerIndex, layer: newLayer, isAdditional: true }))
    assetLayerId = newLayer.id
    newLayerIds.push(newLayer.id)
  }

  // set reference for single file only (without modal window)
  if (files.length === 1) {
    dispatch(setInitialReference(files[0].file))
  }

  const referenceVideo = Selectors.getReferenceVideoAsset(getState())
  files.forEach(({ file, timePosition }) => {
    const asset = createAssetFromSourceFile(file, {
      layerId: assetLayerId,
      startTime: timePosition,
      videoSize: { width: referenceVideo.width, height: referenceVideo.height },
    })
    newAssets.push(asset)
  })

  dispatch(ActionsLayer.addAsset({ asset: newAssets, newLayerIds }))
  // eslint-disable-next-line consistent-return
  return newAssets
}
